import { color, fontSize, fontWeight } from '@evrekadev/evreka-ui-components'
import { Button, Modal } from 'components'
import React, { useState } from 'react'
import { Homepage } from './components/Homepage'
import { AiChat02Icon } from './icons'
import './styles.css'
import { AIProvider, useAIContext } from './context/AIProvider'
import { ActionLayout } from './components/ActionLayout'
import styled from 'styled-components'
import { useTranslation } from 'utils/useTranslation'
import { AssistantLayout } from './components/AssistantLayout'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'services/slices/auth'
import { AIActions } from './types'
import { Feedback } from './components/Feedback/Feedback'

export const AI: React.FC = () => {
  const { t } = useTranslation('pages.ai')
  const [isOpen, setIsOpen] = useState(false)
  const closeModal = () => setIsOpen(false)
  const user = useSelector(selectCurrentUser)

  if (!user?.has_ai_feature) return null

  return (
    <>
      <Button
        variant="text"
        onlyIcon
        color="secondary"
        iconLeft={AiChat02Icon}
        onClick={() => setIsOpen(true)}
      />
      <Modal
        id="ai-modal"
        noFooter
        isOpen={isOpen}
        onRequestClose={closeModal}
        heading={t('title')}
      >
        {isOpen && (
          <AIProvider>
            <Content />
          </AIProvider>
        )}
      </Modal>
    </>
  )
}

const Content: React.FC = () => {
  const { page } = useAIContext()
  const isAssistant = page ? page.endsWith('_ASSISTANT') : false
  const isFeedback = page === AIActions.FEEDBACK

  if (isFeedback) {
    return <Feedback />
  }

  if (isAssistant) {
    return <AssistantLayout />
  }

  if (page) {
    return <ActionLayout />
  }

  return <Homepage />
}

const _Beta = styled.div`
  border: 1px solid ${color('green200')};
  padding: 0px 4px;
  background-color: ${color('green25')};
  color: ${color('green500')};
  border-radius: 12px;
  ${fontSize('text_xxs')}
  ${fontWeight('medium')}
  position: absolute;
  top: -12px;
  left: -24px;
`

const _AIButtonStyled = styled(Button)`
  padding-left: 6px;
  position: relative;
  &:hover {
    background-color: ${color('pink25')};
  }
  p {
    color: ${color('pink500')};
  }
`

// const clientData = [
//   {
//     clientName: 'CoffeeStar',
//     totalEarnings: 1000,
//     totalExpenses: 500,
//     totalProfit: 500,
//   },
//   {
//     clientName: 'GreenLeaf',
//     totalEarnings: 2000,
//     totalExpenses: 1000,
//     totalProfit: 1000,
//   },
//   {
//     clientName: 'RedRock',
//     totalEarnings: 3000,
//     totalExpenses: 1500,
//     totalProfit: 1500,
//   },
//   {
//     clientName: 'OceanWave',
//     totalEarnings: 4000,
//     totalExpenses: 2000,
//     totalProfit: 2000,
//   },
// ]

// const hasSeenAIConfetti = localStorage.getItem('hasSeenAIConfetti') === 'true'

//   const [isConfettiActive, setIsConfettiActive] = useState(false)
//   const fancyButtonRef = useRef<HTMLButtonElement>(null)

//   const [isModalOpen, setIsModalOpen] = useState(false)
//   const [selectedAction, setSelectedAction] = useState<AIActions>()
//   const [employeeResponse, setEmployeeResponse] = useState<any>()

//   const getResults = async () => {
//     const response = await fetch(
//       `https://360-int01.evreka.co/ai/v1/reports/employee_performance/${clientId}`,
//       {
//         headers: {
//           'X-Application-Token': window.envVariables.REACT_APP_AI_AUTH_TOKEN,
//           'X-Environment': 'int03',
//         },
//       },
//     )
//     const data = await response.json()
//     setEmployeeResponse(JSON.stringify(data))
//     console.log(data)
//   }

//   useEffect(() => {
//     if (!hasSeenAIConfetti) {
//       localStorage.setItem('hasSeenAIConfetti', 'true')
//       const timer = setTimeout(() => {
//         setIsConfettiActive(true)
//       }, 300)

//       return () => {
//         clearTimeout(timer)
//       }
//     }
//   }, [])

//   useEffect(() => {
//     getResults()
//   }, [])

//   const selectedActionData = [...actions, ...assistants, ...execActions].find(
//     ({ action }) => action === selectedAction,
//   ) as ActionType

//   return (
//     <>
//       <Confetti
//         numberOfPieces={isConfettiActive ? 100 : 0}
//         recycle={false}
//         onConfettiComplete={(confetti) => {
//           setIsConfettiActive(false)
//           confetti?.reset()
//         }}
//         confettiSource={{
//           x: fancyButtonRef.current?.offsetLeft || 0,
//           y: fancyButtonRef.current?.offsetTop || 0,
//           w: 100,
//           h: 100,
//         }}
//       />
//       <AIButtonStyled
//         ref={fancyButtonRef}
//         onClick={() => setIsModalOpen(true)}
//         iconLeft={AiNetworkIcon}
//         variant="outline"
//       >
//         Evreka AI
//         <Beta>BETA</Beta>
//       </AIButtonStyled>

//       <Modal
//         noFooter
//         isOpen={isModalOpen}
//         onRequestClose={() => setIsModalOpen(false)}
//         heading={'Evreka AI'}
//         headingElement={
//           <Flex directionColumn="zero" gap={0.25}>
//             <Typography fontSize="text_lg" fontWeight="semibold">
//               Evreka AI
//             </Typography>
//             <Typography
//               onClick={() => setRemoveIsUserExec((r) => !r)}
//               style={{
//                 marginLeft: 0,
//                 cursor: 'initial',
//               }}
//               fontSize="text_md"
//               color="grey600"
//             >
//               Evreka AI helps you analyze your data to drive your business forward
//             </Typography>
//           </Flex>
//         }
//         supportingText="Evreka AI is a powerful tool that can help you chat with your data."
//       >
//         {selectedAction && (
//           <Grid columns={!selectedAction.includes('_ASSISTANT') ? '3fr 2fr' : '1fr'} fullHeight>
//             {!selectedAction.includes('_ASSISTANT') && (
//               <DataSidebar
//                 data={
//                   selectedAction === AIActions.CLIENT_SUMMARY
//                     ? clientData
//                     : JSON.parse(employeeResponse ?? '[]')
//                 }
//                 back={() => {
//                   setSelectedAction(undefined)
//                 }}
//                 action={[...actions, ...execActions].find((a) => a.action === selectedAction)!}
//               />
//             )}
//             <Chat
//               assitantId={(assistants.find((a) => a.action === selectedAction) as any)?.assitantId}
//               starter={{
//                 action: selectedActionData?.action,
//                 description: selectedActionData?.description,
//                 title: selectedActionData?.title,
//                 data:
//                   selectedAction === AIActions.CLIENT_SUMMARY
//                     ? clientData
//                     : JSON.parse(employeeResponse ?? '[]'),
//               }}
//             />
//           </Grid>
//         )}
//         {!selectedAction && (
//           <AIMenu removeIsUserExec={removeIsUserExec} setSelectedAction={setSelectedAction} />
//         )}
//       </Modal>
//     </>
//   )
// }

// const AIMenu: React.FC<{
//   setSelectedAction: React.Dispatch<React.SetStateAction<AIActions | undefined>>
//   removeIsUserExec?: boolean
// }> = ({ setSelectedAction, removeIsUserExec }) => (
//   <Flex
//     directionColumn="zero"
//     between="zero"
//     gap={1.5}
//     style={{
//       padding: 16,
//     }}
//   >
//     <Grid columns={2} gap={1}>
//       {(removeIsUserExec ? execActions : actions).map((starter, i) => (
//         <Starter
//           key={i}
//           title={starter.title}
//           description={starter.description}
//           icon={starter.icon}
//           onClick={() => setSelectedAction(starter.action)}
//         />
//       ))}
//       <Starter
//         title={'Help Us Improve Evreka AI'}
//         description={'Provide feedback to help us improve our services'}
//         icon={<CursorInfo01Icon height={40} width={40} color={ThemeColors.grey700} />}
//         onClick={() => {}}
//         isSecondary
//       />
//     </Grid>
//     <Separator
//       style={{
//         background: ThemeColors.grey200,
//       }}
//     />
//     <Flex directionColumn="zero" gap={1}>
//       {assistants.map((assistant, i) => (
//         <Starter
//           key={i}
//           title={assistant.title}
//           description={assistant.description}
//           icon={assistant.icon}
//           color={assistant.color}
//           onClick={() => setSelectedAction(assistant.action)}
//         />
//       ))}
//     </Flex>
//   </Flex>
// )

// const Beta = styled.div`
//   border: 1px solid ${color('blue200')};
//   padding: 0px 4px;
//   background-color: ${color('blue25')};
//   color: ${color('blue500')};
//   border-radius: 8px;
//   ${fontSize('text_xxs')}
//   ${fontWeight('semibold')}
//   ${shadow('sm')}
//   position: absolute;
//   top: -12px;
//   left: -24px;
// `

// const AIButtonStyled = styled(Button)`
//   padding-left: 6px;
//   position: relative;
//   &:hover {
//     background-color: ${color('pink25')};
//   }
//   p {
//     color: ${color('pink500')};
//   }

//   border-color: ${color('pink200')};

//   svg {
//     width: 20px;
//     height: 20px;
//     color: ${color('pink500')};
//   }
// `
